import { useState, useContext, useEffect, forwardRef } from "react";
import {
  Dialog,
  DialogContent,
  List,
  ListItem,
  Divider,
  Typography,
  Slide,
  AppBar,
  Toolbar,
  IconButton,
  Menu,
  MenuItem,
  Box,
  Chip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import request from "../../../utilities/requests";
import { EventContext } from "../../../contexts/EventContext";
import { toast } from "../../../utilities/SnackBarUtils";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const steps = [
  "Select Ticket to Transfer",
  "Select New Event",
  "Select New Ticket",
  "Add Notes (Optional)",
  "Review & Confirm",
];

const WaitListDialog = ({ open, close }) => {
  const { pairingEvent } = useContext(EventContext);
  const [waitList, setWaitList] = useState([]);

  const [loading, setLoading] = useState(false);

  const [menuAnchor, setMenuAnchor] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);

  useEffect(() => {
    if (open && pairingEvent) {
      getWaitList();
    }
  }, [open, pairingEvent]);


  const getWaitList = async () => {
    const result = await request(
      `ticketing/waitlist?eventId=${pairingEvent?.event?._id}`,
    );
    if (result.success) {
      setWaitList(result.waitList);
    }
  };

  const handleClose = () => {
    close();
  };

  const handleMenuOpen = (event, user) => {
    setMenuAnchor(event.currentTarget);
    setSelectedUser(user);
  };

  const handleMenuClose = () => {
    setMenuAnchor(null);
    setSelectedUser(null);
  };

  const handleRemove = async () => {
    if (!selectedUser) return;

    console.log(selectedUser)
    const body = {
      userId: selectedUser.userId,
      eventId: pairingEvent.event._id
    }
    const result = await request('ticketing/removefromwaitlist','post',body);
    if (result.success) {
      getWaitList();
      toast.success("User removed from waitlist successfully")
    }

  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullScreen
      TransitionComponent={Transition}
    >
      <AppBar sx={{ position: "relative" }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            Waitlist
          </Typography>
        </Toolbar>
      </AppBar>

      <DialogContent>
        {waitList.length === 0 ? (
          <Typography variant="body1">
            No users currently on the waitlist.
          </Typography>
        ) : (
          waitList.map((group) => (
            <div key={group.ticketTypeId} style={{ marginBottom: 24 }}>
              <Typography variant="h6" sx={{ mb: 1 }}>
                {group.ticketType}
              </Typography>

              <List dense>
                {group.users.map((u, idx) => (
                  <div key={u._id}>
                    <ListItem disablePadding>
                      <Box
                        sx={{
                          width: "100%",
                          display: "flex",
                          alignItems: "flex-start",
                          justifyContent: "space-between",
                          gap: 1,
                        }}
                      >
                        {/* LEFT: USER INFO + META */}
                        <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                          <Typography variant="body1" sx={{ fontWeight: 500 }}>
                            {u.firstName} {u.lastName}
                          </Typography>

                          <Typography variant="body2" color="text.secondary">
                            {u.email}
                          </Typography>

                          {u.phone && (
                            <Typography variant="body2" color="text.secondary">
                              {u.phone}
                            </Typography>
                          )}

                          {/* Chips wrap under the contact info on mobile */}
                          <Box
                            sx={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: 0.5,
                              mt: 0.5,
                            }}
                          >
                            {u.status && (
                              <Chip
                                size="small"
                                label={u.status}
                                color={u.status === "notified" ? "success" : "default"}
                                variant="outlined"
                              />
                            )}

                            {u.added && (
                              <Chip
                                size="small"
                                label={`Added ${u.added}`}
                                variant="outlined"
                              />
                            )}

                            {u.notified && (
                              <Chip
                                size="small"
                                label={`Notified ${u.notified}`}
                                color="success"
                                variant="outlined"
                              />
                            )}
                          </Box>
                        </Box>

                        {/* MENU */}
                        <IconButton
                          size="small"
                          onClick={(e) => handleMenuOpen(e, u)}
                          sx={{ flexShrink: 0 }}
                        >
                          <MoreVertIcon />
                        </IconButton>
                      </Box>
                    </ListItem>

                    {idx !== group.users.length - 1 && <Divider />}
                  </div>
                ))}
              </List>

              <Divider sx={{ mt: 2 }} />
            </div>
          ))
        )}
        <Menu
          anchorEl={menuAnchor}
          open={Boolean(menuAnchor)}
          onClose={handleMenuClose}
        >
          <MenuItem
            onClick={(e) => {
              e.stopPropagation();
              handleRemove();
            }}
          >
            Remove
          </MenuItem>
        </Menu>
      </DialogContent>
    </Dialog>
  );
};

export default WaitListDialog;
